import { render, staticRenderFns } from "./Swipers.vue?vue&type=template&id=78fa310c&scoped=true"
import script from "./Swipers.vue?vue&type=script&lang=js"
export * from "./Swipers.vue?vue&type=script&lang=js"
import style0 from "./Swipers.vue?vue&type=style&index=0&id=78fa310c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fa310c",
  null
  
)

export default component.exports